import axios from "axios";

export const httpEgismob = axios.create({
    baseURL: "https://egismob.com.br/api/",
});
